// Payroll — my payslips.
import { useEffect, useState } from "react";
import { api } from "../../shared/api/client";
import { PageHeader } from "../../shared/components/PageHeader";
import { Empty, Loading } from "../../shared/components/Empty";
import { Pill } from "../../shared/components/Pill";

type Payroll = {
  id: number; pay_period: string; base_salary: number; overtime_pay: number; total_pay: number;
  tax: number; insurance: number; net_pay: number; status: string; paid_at: string | null;
};

export default function PayrollPage() {
  const [items, setItems] = useState<Payroll[] | null>(null);
  useEffect(() => { api.get<Payroll[]>("/hr/me/payslips").then((r) => setItems(r.data)); }, []);

  return (
    <>
      <PageHeader title="급여" subtitle="내 명세서"/>
      <div className="t-grid cols-1">
        {items === null && <Loading/>}
        {items?.length === 0 && <Empty msg="명세서가 없습니다"/>}
        <div className="t-card" style={{ padding: 0 }}>
          <div className="t-list" style={{ padding: 16 }}>
            {items?.map((p) => (
              <div key={p.id} className="t-row">
                <span className="title" style={{ width: 100 }}>{p.pay_period}</span>
                <span className="meta">기본급</span>
                <span className="num">{Math.round(p.base_salary).toLocaleString()}</span>
                <span className="meta">연장수당</span>
                <span className="num">{Math.round(p.overtime_pay).toLocaleString()}</span>
                <span className="meta" style={{ marginLeft: "auto" }}>실수령</span>
                <span className="num" style={{ fontWeight: 700, color: "var(--p-700)" }}>{Math.round(p.net_pay).toLocaleString()}원</span>
                <Pill kind={p.status === "PAID" ? "ok" : "warn"}>{p.status}</Pill>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
